import type { LegacyGenerationJob } from "~/entities/chat";

export interface JobActivityCounts {
    /** In-flight джобы: queued / in_progress / recovering. */
    active: number;
    /** Ошибочные джобы: failed / expired. */
    errored: number;
}

// Один проход по job-карте чата. Заменяет бывшие дубли в VirtualMessageList
// (activeJobCount ≡ liveJobCount, errorJobCount ≡ failedJobCount — считались
// дважды). Прочие статусы (done / canceled / …) не учитываются.
export function countActiveAndErroredJobs(
    jobsByMessageId: Record<string, LegacyGenerationJob>,
): JobActivityCounts {
    let active = 0;
    let errored = 0;
    for (const job of Object.values(jobsByMessageId)) {
        if (job.status === "queued" || job.status === "in_progress" || job.status === "recovering") {
            active += 1;
        } else if (job.status === "failed" || job.status === "expired") {
            errored += 1;
        }
    }
    return { active, errored };
}
